<template>
  <div class="wrap">
    <es-loader/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import EsLoader from '@/components/EsLoader.vue';

export default {
  components: {
    EsLoader,
  },
  created() {
    localStorage.clear();
    sessionStorage.clear();
    const logoutUrl = this.properties['SECURITY-LOGOUT_URL'];
    if (this.$store.getters.user) {
      this.signOff();
    }
    window.location.assign(logoutUrl || '/uid/login');
  },
  computed: {
    ...mapGetters({
      properties: 'propertiesModule/properties',
    }),
  },
  methods: {
    ...mapActions([
      'signOff',
    ]),
  },
};
</script>

<style lang="sass" scoped>
  .wrap
    height: 100vh
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
</style>
